export default "__VITE_ASSET__BRVRcIdB__"